// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","3065":"22f23411","4398":"22f23411","4740":"510c1640","6909":"52cb286f"}[chunkId] + ".chunk.css";
};